@if (trafficLights) {
    <div class="container">
        @for (trafficLight of trafficLights; track trafficLight.label) {
            <div
                class="traffic-light"
                [pTooltip]="trafficLight.label + ':\n' + trafficLight.description"
                tooltipPosition="top"
                [ngClass]="getColorForTrafficLight(trafficLight)"
                [attr.role]="'meter'"
                [attr.aria-label]="trafficLight.label"
                [attr.aria-valuetext]="trafficLight.description"
            ></div>
        }
    </div>
}
